import React from "react";
import {TravelQuotation} from "../model/quotation";
import {Stage} from "../api/model/scenario";

interface Props {
    nextStepListener: (quotation: TravelQuotation) => void;
    backStepListener: (quotation: TravelQuotation, stepCallback?: (stage: Stage) => void) => void;
}

export const TravelStepContext = React.createContext<Props>({
    nextStepListener: (quotation: TravelQuotation) => {},
    backStepListener: (quotation: TravelQuotation) => {}
});
